import React, { memo } from "react";
import PropTypes from "prop-types";
import { Link, useLocation } from "react-router-dom";
import { AppBar, Box, Button, Hidden, IconButton, withStyles } from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import HomeIcon from "@material-ui/icons/HomeRounded";
import NavigationDrawer from "./NavigationDrawer";
import SettingsIcon from '@material-ui/icons/Settings';
import StorageIcon from '@material-ui/icons/Storage';
import ArchiveIcon from '@material-ui/icons/Archive';
import ContactMailIcon from '@material-ui/icons/ContactMail';
import Logo from "../Logo";

const navBarHeight = 70

const styles = theme => ({
  appBar: {
    background: theme.palette.primary.main
  },
  toolbar: { display: "flex", justifyContent: "space-between" },
  menuButtonText: {
    fontSize: theme.typography.body1.fontSize,
    fontWeight: theme.typography.h6.fontWeight,
    color: theme.palette.common.white,
  },
  inactive: { textDecoration: "none !important" },
  buyButton: {
    backgroundColor: theme.palette.common.white,
    fontSize: theme.typography.body1.fontSize,
    fontWeight: theme.typography.h6.fontWeight,
  },
  active: {
    textDecoration: 'none',
    borderBottom: `2px solid white`,
  },
  icon: { color: theme.palette.common.white },
  divider: { backgroundColor: theme.palette.common.white },
  mobileButton: { color: theme.palette.common.white },
  profileMenu: { backgroundColor: theme.palette.primary.main },
  cPrimary: { color: theme.palette.primary.main },
});

function NavBar(props) {
  const { classes, handleMobileDrawerOpen, handleMobileDrawerClose, mobileDrawerOpen, selectedTab } = props;
  const location = useLocation();

  const basicMenuItems = [
    { name: "Home", link: "/", icon: <HomeIcon className={classes.icon} /> },
    { name: "Solutions", link: "/solutions", icon: <ArchiveIcon className={classes.icon} /> },
    { name: "Services", link: "/services", icon: <SettingsIcon className={classes.icon} /> },
    { name: "Company", link: "/company", icon: <StorageIcon className={classes.icon} /> },
    { name: "Contact", link: "/contact", icon: <ContactMailIcon className={classes.icon} /> },
  ];

  return (
    <>
      <AppBar position="sticky" className={classes.appBar} elevation={0}>
        <Box display='flex' alignItems='center' style={{ height: navBarHeight }} px={2}>
          <Box flexGrow={1}><Link to='/'><Logo /></Link></Box>
          <Box display='flex'>
            <Hidden mdUp>
              <IconButton className={classes.mobileButton} onClick={handleMobileDrawerOpen} aria-label="Open Navigation">
                <MenuIcon />
              </IconButton>
            </Hidden>
            <Hidden smDown>
              {basicMenuItems.map(element => {
                if (element.link) {
                  return (                    
                    <Link key={element.name} to={element.link} className={classes[location.pathname === element.link ? 'active' : 'inactive']} onClick={handleMobileDrawerClose}>
                      <Button color="primary" size="large" classes={{ text: classes.menuButtonText }} style={element.link === '/nxwarehouse' ? {paddingTop: 5} : null} >
                        {element.name}
                      </Button>
                    </Link>
                  );
                }
                return (
                  <Button color="primary" size="large" onClick={element.onClick} classes={{ text: classes.menuButtonText }} key={element.name}>
                    {element.name}
                  </Button>
                );
              })}
            </Hidden>
          </Box>
        </Box>
      </AppBar>
      <NavigationDrawer
        // menuItems={basicMenuItems.concat(mobileItems)} Add back when we put login back
        menuItems={basicMenuItems}
        anchor="left"
        open={mobileDrawerOpen}
        selectedItem={selectedTab}
        onClose={handleMobileDrawerClose}
      />
    </>
  );
}

NavBar.propTypes = {
  classes: PropTypes.object.isRequired,
  handleMobileDrawerOpen: PropTypes.func,
  handleMobileDrawerClose: PropTypes.func,
  mobileDrawerOpen: PropTypes.bool,
  selectedTab: PropTypes.string,
  openRegisterDialog: PropTypes.func.isRequired,
  openLoginDialog: PropTypes.func.isRequired
};

export default withStyles(styles, { withTheme: true })(memo(NavBar));
